export default __webpack_public_path__ + "static/media/vosxod.4b167ffd.png";